import { RadioButton } from "@ts-digital/vrc";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import VaporAccordion from "../../../../vapor/accordion";
import "./style.css";

const NatureModalContent = ({ onChange, initialValue, isModal, setIsNatureModal, selected, setSelected }) => {

  const [opened, setOpened] = useState(initialValue);

  const exemptionNatures = useSelector(state => state.precog.vat.exemptionNatures.list);

  const groupedRates = () => {
    let objs = {};
    let items = [];
    exemptionNatures.map(exemption => {
      if (!objs[exemption.nature]) {
        objs[exemption.nature] = { description: exemption.nature, articles: [] };
      }
      return objs[exemption.nature].articles.push(exemption);
    });
    for (let obj in objs) {
      if (objs.hasOwnProperty(obj)) {
        items.push(objs[obj]);
      }
    }
    return items;
  };

  return (
    <div className="dbx-precog-drawer-nature-root">
      {groupedRates().map((exemption, index) => {
        return (
          <VaporAccordion
            key={`VaporAccordion_${index}`}
            className={"precog-drawer-nature-accordion"}
            itemId={"nature_" + exemption.description}
            opened={opened === "nature_" + exemption.description}
            onChange={val => setOpened(val)}
            title={exemption.description}
            description={exemption.articles.length + " Esenzioni"}
          >
            {exemption.articles.map(it => {
              return (
                <div
                  className="precog-drawer-nature-item"
                  key={`nature_description_${exemption.description}_${it.id}`}
                >
                  <RadioButton
                    checked={selected?.id === it.id}
                    onChange={() => {
                      setSelected({id: it.id, nature: it.nature });
                      onChange(it.id, it.nature);
                      if (isModal) {
                        setIsNatureModal(false);
                      }
                    }}
                  />
                  <div
                    className="precog-drawer-nature-item-description"
                    onClick={() => setSelected({id: it.id, nature: it.nature })}
                  >
                    <span>{it.nature}</span> {it.description}
                  </div>
                </div>
              );
            })}
          </VaporAccordion>
        );
      })}
    </div>
  );
};

export default NatureModalContent;
